/**
 * Schema of OcorrenciaTracking
 * @author hugohiga
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import OcorrenciaTracking from '@/model/resource/OcorrenciaTracking'

export default (model: OcorrenciaTracking): Schema => ({
  idOcorrenciaTrackingResponsavelPk: {
    content: model.idOcorrenciaTrackingResponsavelPk,
    editable: false,
  },

  idOcorrenciaExterna: {
    content: model.idOcorrenciaExterna,
  },

  idOcorrenciaExternaAlt: {
    model: 'idOcorrenciaExterna',
    content: model.idOcorrenciaExterna,
    textContent: null,
    input: InputType.MASK,
    meta: {
      required: true,
      mask: '###########################',
      selectall: true,
    },
  },

  descricao: {
    content: model.descricao,
  },

  descricaoAlt: {
    model: 'descricao',
    content: model.descricao,
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '63',
    },
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
